import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { getLangFromPath } from "@/i18n";

/**
 * Scroll to top on route change, but NOT on language-only switch.
 * We compare the "page key" (path without the leading /lang segment)
 * and also honour a state flag set by the language switcher.
 */
export default function ScrollToTop() {
  const location = useLocation();
  const previous = useRef({ page: null, hash: null });

  useEffect(() => {
    const lang = getLangFromPath(location.pathname);
    const parts = location.pathname.split("/").filter(Boolean);
    // page key is everything AFTER the language segment
    const page = parts.slice(1).join("/") || "home";

    const isLanguageSwitch = !!location.state?.languageSwitch;
    const isSamePage = previous.current.page === page;

    if (!isLanguageSwitch && !isSamePage && !location.hash) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }

    if (location.hash) {
      const id = location.hash.replace(/^#/, "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 60);
      }
    }

    previous.current = { page, hash: location.hash };
    // update document lang
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang === "mx" ? "es-MX" : "en";
    }
  }, [location.pathname, location.hash, location.state]);

  return null;
}
